 
import { getID } from "src/libs/utilities";
import { LANDING_TYPE_CONTENT } from "../interfaces";

export default function ymap():any[] {
    return [
        {
          "id": getID( LANDING_TYPE_CONTENT.YANDEX_MAP ),
          "type": LANDING_TYPE_CONTENT.YANDEX_MAP,
          "coordinates": [53.320261, 58.70963, 5],
          "markers": [
            {
              "id": "marker-1",
              "coordinates": [49.975716, 46.72601],
              "color": "#508750"
            },
            {
              "id": "marker-2",
              "coordinates": [53.320261, 58.70963],
              "color": "#508750"
            },
            {
              "id": "marker-2",
              "coordinates": [56.298244, 36.613987],
              "color": "#5b6d45"
            }
          ],
          defaultTitle: "Карта с простыми маркерами"
        }
    ]
}